
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/photos",
      function () {
        return require("private-next-pages/profile/photos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/photos"])
      });
    }
  